
import { PractitionerReducer } from './PractitionerReducer';
import PractitionerConsumptionToSettleReducer from './Practitioner.ConsumptionToSettle.Reducer';
import PractitionerChangeStatusReducer from './Pracittioner.ChangeStatus.Reducer';

// state
import { PractitionerState } from '../../states/PractitionerState';

// Reduce common functions
import * as CommonFunctions from '../Common/Functions';

// Exporta el reducer combinado
export const CombinedPractitionerReducer = CommonFunctions.reduceReducers<PractitionerState>(
  PractitionerReducer,
  PractitionerConsumptionToSettleReducer,
  PractitionerChangeStatusReducer
);

